import { BritishColumbiaObstetricalFileSignOff } from "@/Patient/Models/ObstetricalFile/BritishColumbia/Part2/BritishColumbiaObstetricalFileSignOff";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "../../../Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileSection18 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private readonly section18Id = "Section18";

    public render(): JSX.Element {
        return (
            <div className="section initials-mapping">
                {this.renderTitle(18, "SignOffsLabel")}
                <table className="no-border-section-table">
                    <tbody>
                        {this.renderSignOffs()}
                    </tbody>
                </table>
            </div>
        );
    }

    private renderSignOffs(): JSX.Element[] {
        const model = this.props.form.Section18;

        return model.map((signoff, index) => (
            <tr key={`${this.section18Id}_signOff_index_${signoff.getId()}`}>
                <td>
                    {this.renderInlineTextbox({
                        labelSuffix: this.renderMultipleLabel(
                            "",
                            `${index + 1}. `,
                            this.getLabelSuffix(`(${this.getString("NameLabel").toLowerCase()})`, "extra-info-label")
                        ),
                        id: `${signoff.getId}`,
                        value: signoff.CareProviderName,
                        onChange: value => this.mutateRowState(signoff.getId(), p => p.CareProviderName = value),
                        maxLength: this.page2FieldLimits.Section18_Name_1.MaxChars
                    })}
                </td>
                <td>
                    {this.controlRenderer.renderInlineRadio({
                        value: signoff.CareProviderRole,
                        items: this.getCareProviderRoleOptions(),
                        onChange: value => this.mutateRowState(signoff.getId(), p => p.CareProviderRole = value, true),
                        id: "Section18_signOff_CareProviderRole",
                        allowDeselect: true
                    })}
                </td>
            </tr>
        ));
    }

    private mutateRowState(id: number, mutation: (state: BritishColumbiaObstetricalFileSignOff) => void, updateForm: boolean = false): void {
        this.props.mutateModelState(
            () => {
                this.props.form.Section18.mutate(
                    p => mutation(p),
                    p => p.getId() === id
                );
            },
            () => {
                if (updateForm)
                    this.props.handleFormUpdate();
            },
            false
        );
    }
}

export { BritishColumbiaObstetricalFileSection18 };
